// extracted by mini-css-extract-plugin
module.exports = {"container":"Label_container__3Usbx"};